// extracted by mini-css-extract-plugin
module.exports = {"main":"Text_main_i3_ts","content":"Text_content_36K9x"};